import React, { ReactNode, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import useIsMobile from '../../../hooks/global/UseIsMobile';
import { MOBILE_TAB_BAR_PAGE_ID } from './MobileTabBar';

/**
 * Puts a page's own items into the phone's bottom tab bar (`MobileTabBar`) in place of the default ones.
 * Children are rendered as the bar's items — give them `mobile-tab-bar__item` / `__icon` / `__label`.
 * Desktop: renders nothing (the page shows its own controls there). Same portal idea as `MobilePageHeader`.
 */
const MobileTabBarItems: React.FC<{ children: ReactNode }> = ({ children }) => {
  const isMobile = useIsMobile();
  const [slot, setSlot] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setSlot(isMobile ? document.getElementById(MOBILE_TAB_BAR_PAGE_ID) : null);
  }, [isMobile]);

  return slot ? createPortal(children, slot) : null;
};

export default MobileTabBarItems;
